// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatBroadcastItem_wrapper__2DRP-","active":"ChatBroadcastItem_active__1_xNM","message":"ChatBroadcastItem_message__3KDdU"};